import React, { FC } from "react";
import { ResourceTypeLink } from "@evergis/api";

import { DeleteProjectsContent } from "./DeleteProjectsContent";
import { DeleteLayersContent } from "./DeleteLayersContent";
import { DeleteTablesContent } from "./DeleteTablesContent";
import { DeleteResourcesContentProps } from "../types";

export const DeleteContent: FC<DeleteResourcesContentProps> = ({ type, layers, tables, projects, toggle, checked }) => {
  const showLayerCheckbox = type === ResourceTypeLink.Project && layers.length > 0;
  const showSourceCheckbox = type !== ResourceTypeLink.Table && tables.length > 0;

  return (
    <>
      {(showLayerCheckbox || showSourceCheckbox || type === ResourceTypeLink.Table) && (
        <>
          {type === ResourceTypeLink.Project && (
            <DeleteProjectsContent
              projects={projects}
              layers={layers}
              tables={tables}
              checked={checked}
              toggle={toggle}
            />
          )}
          {type === ResourceTypeLink.Layer && (
            <DeleteLayersContent
              projects={projects}
              layers={layers}
              tables={tables}
              checked={checked}
              toggle={toggle}
            />
          )}
          {type === ResourceTypeLink.Table && (
            <DeleteTablesContent
              projects={projects}
              layers={layers}
              tables={tables}
              checked={checked}
              toggle={toggle}
            />
          )}
        </>
      )}
    </>
  );
};
